import classNames from 'classnames';
import React, { FC, ReactElement } from 'react';
import { Loader } from '@whitesharx/starfall-frontend-ui-kit';

import { buttonStyles, hiddenStyles, iconStyle, loaderStyles } from './styles.css';

export type GameControlButtonProps = {
  icon: ReactElement;
  onClick: () => void;
  className?: string;
  loading?: boolean;
  disabled?: boolean;
};

const GameControlButton: FC<GameControlButtonProps> = ({ icon, onClick, className, loading, disabled }) => (
  <button className={classNames(buttonStyles, className)} disabled={loading || disabled} onClick={onClick}>
    {!loading ? (
      icon
    ) : (
      <div className={classNames({ [hiddenStyles]: loading })}>
        {React.cloneElement(icon, {
          className: classNames(iconStyle, icon.props.className),
        })}
      </div>
    )}
    {loading && <Loader.Mini className={loaderStyles} size="18" />}
  </button>
);

export default GameControlButton;
